// extracted by mini-css-extract-plugin
module.exports = {"panel":"_995efb5","runners":"_78c5aca","runner":"_57b235c","sgmRunner":"_a7bf028","contentWrapper":"_6dfb77a"};